import React, { useEffect, useState } from "react";
import { Alert, Button, Modal, Typography } from "antd";
import { CheckOutlined, CloseOutlined, InfoCircleFilled } from "@ant-design/icons";
import { usePrevious } from "../../../../hooks";
import RegionSelector from "../../../common/RegionSelector/RegionSelector";
import { IAB_CHOICES_SYSTEM_IDS, REGION_LABELS, USNAT_CODE } from "../helper";
import { countryToRegionMap } from "../../../../constants";

const AddRegionsModal = (props) => {
  const { openRegionsModal, handleCancel, addRegions, systemPurposesJS } = props;

  const [ geoScopes, setGeoScope ] = useState({
    appliesGeos : props.usPrivacyRegulation.appliesGeos ?? [],
    exclusionGeos : props.usPrivacyRegulation.exclusionGeos ?? []
  })
  const [ selectedCodes, setSelectedCodes] = useState(null);
  const [ showRespectGpcAlert, setShowRespectGpcAlert ] = useState(false);
  const [ geoScopesError, setGeoScopeError ] = useState(false)
  const [ selectedTerritories, setSelectedTerritories ] = useState();
  const [ intermediateUSPRegulationm, setIntermediateUSPRegulation ] = useState(props.usPrivacyRegulation);
  useEffect(()=>{
    if(geoScopesError){
      setGeoScopeError( geoScopes.appliesGeos.length == 0 && geoScopes.exclusionGeos.length == 0 ? "Select at least one Region" : false)
    }
    // props.usPrivacyRegulation.appliesGeos = geoScopes.appliesGeos;
    // props.usPrivacyRegulation.exclusionGeos = geoScopes.exclusionGeos;
  },[geoScopes])

  useEffect(()=>{
    if(props.summaryPageData){
      props.summaryPageData.geoTerritories = selectedTerritories;
    }
  },[selectedTerritories])

  const prevCodes = usePrevious(selectedCodes);

  useEffect(() => {
    
    if(selectedCodes && selectedCodes.length && prevCodes && prevCodes.length && !_.isEqual(selectedCodes, prevCodes)){
      let updatedCategories = _.clone(intermediateUSPRegulationm.categories);
      updatedCategories = updatedCategories.map(cat => {
        if(cat.purposeRef?.systemId === IAB_CHOICES_SYSTEM_IDS.saleAndSharing && cat?.respectGPC) {
          setShowRespectGpcAlert(true);
          cat.respectGPC = cat.respectGPC?.filter((code) => selectedCodes.includes(code)) ?? null;
        }
        return cat;
      })
      setIntermediateUSPRegulation((prev) => ({
        ...prev,
        categories: updatedCategories
      }));
    }
    if(selectedCodes && (selectedCodes.length || prevCodes?.length)) {
      let updatedReg = _.clone(intermediateUSPRegulationm);
      const legislationConfig = updatedReg.configByGeo;
      let usPrefixSelectedCodes = selectedCodes.map(c => c.replace("STATE_", "US_"));
      usPrefixSelectedCodes.forEach((region) => {
        if(!legislationConfig[region]) {
          const parentRegion = countryToRegionMap[region?.replace("US_", "STATE_")]
          legislationConfig[region] = {legislation: parentRegion?.includes("REGION_") ? "regional" : "usnat"}
        }
      })
      const updatedConfigByGeoForVL = Object.fromEntries(
        Object.entries(legislationConfig).filter(([key]) => usPrefixSelectedCodes.includes(key))
      );
      let updatedCategories = updatedReg.categories.map((cat) => {
        // const defaultSysPurpose = systemPurposesJS.find(sysPur => sysPur.id === cat.purposeRef?.id);// DIA-5735
        let updatedConfigByGeo = Object.fromEntries(Object.entries(updatedConfigByGeoForVL)
          .map(([key,value]) => {
            let newKey = key;
            let parentKey = countryToRegionMap[key?.replace("US_", "STATE_")];
            const isRegionalLegislation = parentKey?.includes("REGION_") && updatedConfigByGeoForVL[key]?.legislation === "regional";
            const isCountryLegislation = !parentKey?.includes("REGION_") && updatedConfigByGeoForVL[key]?.legislation === "usnat";
            if (isRegionalLegislation || isCountryLegislation) {
              newKey = parentKey;
            } 
            value = cat.configByGeo[newKey] ?? {defaultLegalBasis: /*defaultSysPurpose?.configByGeo[newKey]?.defaultLegalBasis ??*/ "NOT_APPLICABLE"};
            return [newKey, value];
          }))
        cat.configByGeo = updatedConfigByGeo;
        return cat;
      })
      setIntermediateUSPRegulation((prev) => ({
        ...prev,
        configByGeo: updatedConfigByGeoForVL,
        categories: updatedCategories
      }));
    }
  },[selectedCodes]);

  const handleRegionsSave = () => {
    if(geoScopes.appliesGeos.length == 0 && geoScopes.exclusionGeos.length == 0) {
      setGeoScopeError("Select at least one Region")
      return;
    }
    intermediateUSPRegulationm.appliesGeos = geoScopes.appliesGeos;
    intermediateUSPRegulationm.exclusionGeos = geoScopes.exclusionGeos;
    addRegions(intermediateUSPRegulationm)
  }

  const footer = [
    geoScopesError ? <Typography.Text type="danger">{geoScopesError}</Typography.Text> : null,
    <Button key="cancel" onClick={handleCancel} type="link">Skip for now</Button>,
    <Button key="submit" type="primary" onClick={handleRegionsSave} disabled={geoScopesError}>Add</Button>
  ]
  return (
    <Modal
      title="Add Regions"
      // className="add-regions-modal"
      open={openRegionsModal}
      onCancel={handleCancel}
      onOk={handleRegionsSave}
      onClose={handleCancel}
      footer={footer}
      width={829}
    >
      {showRespectGpcAlert ? <Alert showIcon icon={<InfoCircleFilled/>} message={<div>Modifying the Framework Territories will also modify the GPC regions. You can update the selection under GPC settings.</div>} type="warning"/> : null}
      {/* <div className={`section-content ${geoScopesError ? 'validation-error' : null}`}> */}
        <RegionSelector
          isIncludeExcludeStructure={true}
          setGeoScope={setGeoScope}
          appliesGeos={geoScopes.appliesGeos}
          exclusionGeos={geoScopes.exclusionGeos}
          updatedCodes={() => {}}
          codes={[]}
          showStateString={false}
          selectedRegionsLegend={null}
          setSelectedTerritoriesData={setSelectedTerritories}
          setSelectedCodes={setSelectedCodes}
          onlyUsStates={false}
          filterEEA={false}
          regionLabels={REGION_LABELS}
        />
      {/* </div> */}

    </Modal>
  );
}

export default AddRegionsModal;